import React from "react";
import { Space, Checkbox } from "antd";
import { ICheckboxGroupProps } from "./interface";

const { Group } = Checkbox;

const ZCheckboxGroup: React.FC<ICheckboxGroupProps> = ({
	vertical = false,
	options = [],
	space = "small",
	disabled = false,
	defaultValue = [],
	spaceClassName = "",
	children,
	...rest
}) => (
	<Group defaultValue={defaultValue} {...rest}>
		<Space
			direction={vertical ? "vertical" : "horizontal"}
			size={space}
			className={spaceClassName}
		>
			{options.map(option =>
				option instanceof Object ? (
					<React.Fragment key={`frag_${option.value}`}>
						<Checkbox
							key={option.value}
							value={option.value}
							disabled={disabled || option.disabled}
							defaultChecked={defaultValue.includes(option.value)}
							onChange={option.onChange}
							className={`text-1 ${option.labelClass ?? ""}`}
						>
							{option.label}
						</Checkbox>

						{option?.children}
					</React.Fragment>
				) : (
					<Checkbox
						key={option}
						value={option}
						disabled={disabled}
						defaultChecked={defaultValue.includes(option)}
						className={`text-1`}
					>
						{option}
					</Checkbox>
				)
			)}
		</Space>
		{children}
	</Group>
);

export default ZCheckboxGroup;
